export default __webpack_public_path__ + "fab63b3f3d8d4f109f7fc7a96f1497e4.png";